import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';
import { placeholder } from 'styled-manila';
import { StyleVars } from 'core/utils/Styles';
import { default as Srch } from 'core/icons/SearchIcon';

export const Form = styled.form`
	display: flex;
	width: 100%;
	${placeholder`color: ${getColor('gray8')};`}

	@media (max-width: 767px) {
		${placeholder`color: ${getColor('dustyGray')};`}
		box-shadow: 0 2px 5px 0 rgba(0,0,0,0.05), inset 0 2px 5px 0 rgba(0,0,0,0.05);
		background: ${getColor('white')};
	}
`;

export const Input = styled.input`
	background: ${getColor('porcelain')};
	border: 1px solid ${getColor('alto')};
	box-shadow: none;
	display: block;
	width: 100%;
	padding: 1px 12px 0px 12px;
	transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
	font-size: 16px;
	height: 48px;
	line-height: 48px;
	appearance: none;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		border: none;
		color: ${getColor('dustyGray')};
		background: none;
		height: 72px;
	}

	&[type=search]{
		border-radius: 4px 0 0 4px;
		@media (max-width: 450px) {
			border-radius: 4px;
		}
	}

	::placeholder {
		color: ${getColor('gray8')};

		@media (max-width: ${StyleVars.desktopScreenSm}) {
			color: ${getColor('dustyGray')};
		}
	}

	&:focus {
		box-shadow: none;
		outline: none;
		border-color: ${getColor('morningGlory')};
	}
`;

export const Submit = styled.button`
	height: 48px;
	border-radius: 0 4px 4px 0;
	border: none;
	font-size: 16px;
	line-height: 23px;
	letter-spacing: 0.42px;
	padding: 6px 18px;
	background: ${getColor('primaryBrand')};
	color: ${getColor('white')};

	&:focus {
		outline: none;
	}

	&:hover {
		background: ${getColor('primaryBrandHover')};
	}

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		height: 72px;
		order: -1;
		border-radius: 0;
		background: none;
		color: ${getColor('dustyGray')};
		padding-right: 0;
	}
`;

export const SearchIcon = styled(Srch)`
	margin-top: 6px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
`;
